import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import { commonAppEssayContent } from '../content';

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Overview',
    description:
      'Introductory section explaining what makes a good essay vs. a great one across all Common App prompts.',
    detail: commonAppEssayContent.header.description.join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: commonAppEssayContent.tools.title,
    description: 'Backrs tools and curated resources to support essay writing.',
  });

  useRegisterAgentContext({
    kind: 'section',
    title: 'Essay Prompts',
    description:
      'Seven Common App essay prompts with guidance on what makes each good vs. great, quick self-tests, and a risk to take.',
    detail: commonAppEssayContent.prompts
      .map(
        (p) =>
          `${p.number}. ${p.title}: Good — ${p.good} | Great — ${p.great} | Risk — ${p.riskToTake}`,
      )
      .join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: commonAppEssayContent.finalRealityCheck.title,
    description: 'A final check to determine if your essay is good or great.',
    detail: commonAppEssayContent.finalRealityCheck.body,
  });
};
